const faqItems = [
  {
    q: '17吃瓜网是什么？内容可靠吗？',
    a: '17吃瓜网是一个专注网红黑料与明星爆料的娱乐资讯聚合平台，每日追踪演艺圈最新动态。我们秉持"还原事实、传播真料"的原则，所有内容均经过人工审核团队交叉验证，确保信息真实可靠。覆盖17吃瓜黑料网、17黑料吃瓜等热门版块。',
  },
  {
    q: '17吃瓜爆料的内容来源是什么？',
    a: '17吃瓜爆料信息综合自多方渠道，包括行业内部知情人士投稿、公开社交平台动态追踪、娱乐媒体报道整合以及粉丝一线投稿。所有爆料均标注来源与可信度等级，方便用户自行判断。网红黑料与明星爆料内容分区展示。',
  },
  {
    q: '如何第一时间获取最新黑料吃瓜？',
    a: '收藏17吃瓜网首页并将我们设为浏览器书签，或关注首页"每日更新"时间线。我们保持全天候更新节奏，17c吃瓜黑料爆料通常在事件发生后两小时内完成核实并发布。建议每日早晚各刷新一次。',
  },
  {
    q: '17吃瓜黑料网上的信息会不会涉及隐私侵权？',
    a: '我们严格遵守相关法律法规，所有报道均基于公开信息与合法渠道获取。对于涉及个人隐私的内容，编辑团队会进行脱敏处理后发布。如权利人认为内容涉及侵权，可通过联系页面提交删除申请。',
  },
  {
    q: '娱乐圈黑料这么多，怎么分辨真假？',
    a: '17吃瓜网建立了三级审核机制：AI初筛→编辑复核→主编终审。每条内幕吃瓜内容都附带可信度标签（"已证实""多方佐证""待核实"），帮助用户快速判断。同时我们鼓励用户在评论区理性讨论，共同甄别。',
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[860px] mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-7 md:h-8 rounded-full bg-secondary-500"></div>
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">
            常见问答
          </h2>
        </div>

        <div className="flex flex-col gap-3">
          {faqItems.map((item) => (
            <div
              key={item.q}
              className="rounded-xl bg-background-100 border border-background-200/70 overflow-hidden"
            >
              <div className="p-5 md:p-6">
                <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-800 mb-3 flex items-start gap-3">
                  <span className="text-primary-500 flex-shrink-0 mt-0.5">
                    <i className="ri-question-answer-line"></i>
                  </span>
                  {item.q}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed pl-7">
                  {item.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}